module.exports = __webpack_public_path__ + "static/media/mail.65460827.svg";